import React from "react";

const PlagiarismIcon = ({ fill = "#02C9A6" }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M16 2H6C4.89543 2 4 2.89543 4 4V22C4 23.1046 4.89543 24 6 24H20C21.1046 24 22 23.1046 22 22V8M16 2V6C16 7.10457 16.8954 8 18 8H22M16 2L22 8"
      stroke={fill}
      strokeWidth="1.5"
    />
    <circle cx="12" cy="13" r="3.25" stroke={fill} strokeWidth="1.5" />
    <path
      d="M14 15.5859L16.8284 18.4144"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default PlagiarismIcon;
